<nav class="navbar" role="navigation" aria-label="Barra principal">

  <!-- ── Marca ────────────────────────────────────────────── -->
  <div class="navbar__brand">
    <button
      class="navbar__toggle"
      type="button"
      (click)="toggleSidebar()"
      [attr.aria-label]="isSidebarOpen ? 'Cerrar menú' : 'Abrir menú'">
      <i [class]="isSidebarOpen ? 'pi pi-times' : 'pi pi-bars'"></i>
    </button>

    <button class="navbar__logo" type="button" (click)="goToHome()" aria-label="Ir al inicio">
      <span class="navbar__logo-mark">
        <img
          src="/public/images/logos/logo-logit.svg"
          alt="logo logit"
          class="navbar__logo-mark-image"
        />
      </span>
      <span class="navbar__logo-text">
        LRP <span class="navbar__logo-sub">Proveedores</span>
      </span>
    </button>
  </div>

  <!-- ── Búsqueda ──────────────────────────────────────────── -->
  <div class="navbar__center">
    <app-navbar-search [options]="searchBarOptions" />
  </div>

  <!-- ── Acciones ──────────────────────────────────────────── -->
  <div class="navbar__actions">

    @if (userName) {
      @if (isCompaniesLoading()) {
        <div class="navbar__skeleton"></div>
      } @else {
        <p-select
          [options]="companies()"
          optionLabel="razonSocial"
          optionValue="proveedorExternoID"
          [(ngModel)]="selectedProveedorExternoId"
          [showClear]="false"
          (onChange)="onCompanyChange($event.value)"
          [disabled]="companies().length === 0"
          styleClass="navbar__company-select"
          panelStyleClass="navbar-company-panel"
          appendTo="body"
          placeholder="Empresa"
        />
      }
      <div class="navbar__sep"></div>
    }

    <app-profile-menu />
  </div>

</nav>
